const SHARED_REPORTS_PATH_PREFIX = "/shared";

export const sharedReportsPaths = {
    root: SHARED_REPORTS_PATH_PREFIX,
    share: `${SHARED_REPORTS_PATH_PREFIX}/:shareId`,
    shareSignIn: `${SHARED_REPORTS_PATH_PREFIX}/:shareId/sign-in`,
    unavailable: `${SHARED_REPORTS_PATH_PREFIX}/unavailable`
} as const;

export const sharePath = (shareId: string): string => `${SHARED_REPORTS_PATH_PREFIX}/${shareId}`;

export const shareSignInPath = (shareId: string): string => `${sharePath(shareId)}/sign-in`;
